import React, { useState, useEffect } from 'react';
import DataTable from '../DataTable2/DataTable';
import useGraphQuery from './useGraphQuery';
import NewLoader from '../Loading/NewLoader';

import './graph-data-viz.scss';
import Button from 'selfly-ui-react/dist/components/Button';

import NoData from '../NoData/NoData';

/**
 * Show data in a table format
 *
 * @param {object} props
 * @param {object} props.query - The graphql query object
 * @param {string} props.title - The title for this Data visualization block
 * @param {string} props.className - css class string added to the main container of this visualization
 * @param {object} props.options - Alternate options for Data Table visualization
 * @param {boolean} [props.options.refresh=false] - Set to true to show the fresh button
 * @param {Array<object>} [props.options.columns] - configurations for DataTable columns. if not provided this is automatically generated from query
 * @param {object} [props.options.globalFilter] - The global filters with which the data is filtered in the admin portal. Currently used for filtering data based on organizations
 */
export default function GraphDataTable(props) {
    const { title, options = {} } = props;

    const [columns] = useState(options.columns ? options.columns : []);
    const [data, refresh] = useGraphQuery(undefined, options.refresh);

    useEffect(() => {
        refresh();
    }, [options.globalFilter]);

    if (data === null) {
        return (
            <div className="graph-data-viz graph-data-table">
                <NewLoader text={`Loading ${title}...`} />
            </div>
        );
    }

    if (Array.isArray(data) && data.length === 0) {
        return <NoData title={title} />;
    }

    return (
        <div className={`graph-data-viz graph-data-table ${props.className}`}>
            <header>
                <h3>{title || 'No title'}</h3>
                {options.refresh === true && <Button icon="refresh" className="refresh-button" onClick={refresh} />}
            </header>
            <div className="content">
                <DataTable data={data} columns={columns} filterEnabled={true} rowOnClick={options.onRowClick || false} />
            </div>
        </div>
    );
}
